{
  "_provenance": {
    "ns": "applications",
    "source": "pages/apply/ApplicationStatusPage.tsx and lib/applications-display.ts (#2109 R3 lane L4)"
  },
  "documentKind": {
    "bill_statement": "Bill statement",
    "child_photo": "Child photo",
    "diagnosis_letter": "Diagnosis letter",
    "family_photo": "Family photo",
    "income_verification": "Income verification"
  },
  "status": {
    "admitted": "Admitted",
    "approved": "Approved",
    "denied": "Reviewed",
    "draft": "Draft",
    "needs_more_info": "Needs more info",
    "offer_declined": "Admission letter declined",
    "offer_sent": "Accepted — TRF will contact you",
    "offer_signed": "Acceptance recorded",
    "offer_voided": "Admission letter voided",
    "reviewed": "Reviewed",
    "staff_declined": "Declined",
    "submitted": "Submitted",
    "under_review": "Under review",
    "waitlisted": "Waitlisted",
    "withdrawn": "Withdrawn"
  },
  "statusPage": {
    "nextSteps": {
      "firstPayment": "Your grant is {{amount}} a month. Your first payment month is {{month}}.",
      "firstPaymentPending": "Your first payment month will show here once TRF sets up your grant.",
      "firstPaymentPlanned": "Your first payment is planned for {{month}}.",
      "moreGrants": "Later, you may be able to apply for a Travel grant and a Family Fun grant, if funding is available.",
      "onboardingMeeting": "The onboarding meeting is on {{meeting}}.",
      "title": "What happens next"
    },
    "shownInEnglish": "Shown in English, as TRF wrote it."
  },
  "withdraw": {
    "action": "Withdraw application",
    "confirm": "Withdraw",
    "confirmBody": "TRF will stop reviewing it. If you withdraw by mistake, reply to any email from TRF and we can reopen it this cycle.",
    "confirmTitle": "Withdraw your application?",
    "failed": "Your application was not withdrawn. Please try again.",
    "failedTitle": "Not withdrawn",
    "needsStaff": "To withdraw it now, reply to any email from TRF and we’ll take care of it.",
    "reopenContact": "If this was a mistake, reply to any email from TRF and we can reopen it this cycle.",
    "withdrawnBody": "This application was withdrawn. TRF is no longer reviewing it.",
    "withdrawnHeadline": "This application is closed."
  }
}
